import React, { Component, useState, Fragment } from "react";
import PersonalContext from "./PersonalContext";
import { DateUtils } from "../../utils";
import { SpaceBox } from "../../components/Space";
import DatePickerComponent from "../../components/Datepicker";
import { CONTACT_TIME, CONTACT_REASON } from "../../data/personal";
import SelectComponent from "../../components/Select";
import InputMask from "react-input-mask";
import CloseTab from "../../images/close.svg";
import ContactFormComponent from "../../components/ContactForm";
import moment from "moment";
const imgScale = {
  width: "24px",
  height: "24px"
};
const Icon = props => (
  <img className={props.className} src={props.src} {...imgScale} />
);

class PersonalStep6 extends Component {
  callBackAction;
  constructor(props) {
    super(props);
  }

  onSubmit = () => {
    
  }

  render() {
    const { step6 } = this.context;
    const { onNavigate } = step6;
    const {
      cName,
      cLastName,
      cMobile,
      cEmail,
      cReason,
      cDetail,
      cDate,
      cTime,
      onChangeModel
    } = step6;
    return (
      <div className="form-wrapper">
        <div className="form-group">
          <div className="header" onClick={() => onNavigate(2)}>
            <Icon className="float-right" src={CloseTab} />
          </div>
          <label className="text-blue font-bold mb-3 mt-3 ml-0">
            สนใจให้เจ้าหน้าที่ติดต่อกลับ
          </label>
          <div className="form-group">
            <ContactFormComponent
              productName={'MTI06113'}
              time={CONTACT_TIME}
              reason={CONTACT_REASON}
              cName={cName}
              cLastName={cLastName}
              cMobile={cMobile}
              cEmail={cEmail}
              cReason={cReason}
              cDetail={cDetail}
              cDate={cDate}
              cTime={cTime}
              onChange={onChangeModel}
              onSubmit={() => (window.location.href = "/?callback=1")}
            />
          </div>
        </div>
      </div>
    );
  }
}

PersonalStep6.contextType = PersonalContext;
export default PersonalStep6;
